<bb-table-header-cell [ngClass]="{'check': multiSelect, 'unused': !multiSelect}">
	<bb-check *ngIf="multiSelect" [checked]="allSelected" (onChanged)="selectAllRows()"></bb-check>
</bb-table-header-cell>

<ng-content></ng-content>

<div (clickOutside)="configVisible = false" *ngIf="configurable" class="table-config-button">
	<i class="fas fa-wrench" [ngClass]="{'socials-theme': theme === 'socials-theme', 'opened': configVisible && theme === 'socials-theme'}" (click)="configVisible = !configVisible"></i>
	
	<!-- the expanded config menu -->
	<div [hidden]="!configVisible" class="config" [ngClass]="{'socials-theme': theme === 'socials-theme'}">
		
		<div *ngIf="theme !== 'socials-theme'">
			<span class="reset" (click)="resetLimit()">{{ 'RESET' | translate | lowercase }}</span>
			<span class="header">{{ 'LIST_SETTINGS' | translate }}</span>
		</div>

		<div *ngIf="theme !== 'socials-theme'">
			{{ 'LIMIT' | translate }}
			<input class="limit" type="number" min="5" max="100" [(ngModel)]="limit" (change)="limitChanged.next(limit)">
		</div>

		<div class="header">
			<span class="reset" [ngClass]="{'socials-reset': theme === 'socials-theme'}" (click)="resetColumns()">{{ 'RESET' | translate | lowercase}}</span>
			<span [ngClass]="{'socials-header': theme === 'socials-theme'}">{{ 'COLUMNS' | translate }}</span>
		</div>

		<ng-container *ngIf="theme !== 'socials-theme'">
			<div *ngFor="let column of columns" [hidden]="!column.label">
				{{ column.label }}
				<bb-check [disabled]="column.visible && amountOfVisibleColumns <= 1" [checked]="column.visible" (onChanged)="columnChecked($event, column)"></bb-check>
			</div>
		</ng-container>

		<ng-container *ngIf="theme === 'socials-theme'">
			<div [cdkDropListData]="configColumns" cdkDropList (cdkDropListDropped)="reorder($event)">
				<ng-container *ngFor="let column of configColumns">
					<div cdkDrag cdkDragLockAxis="y">
						<i class="drag fa-regular fa-grip-dots-vertical"></i>
						{{ column.label }}
						<mat-slide-toggle class="toggle" [checked]="column.visible" [disabled]="column.visible && amountOfVisibleColumns <= 1" (change)="columnChecked($event, column)"></mat-slide-toggle>
					</div>
				</ng-container>
			</div>
		</ng-container>
	</div>
</div>
